import { createQueryKeys } from "@lukemorales/query-key-factory";

import { getCompanyInfo } from "@/api/actions/company-info-actions";

export const companyInfoQuery = createQueryKeys("company-info", {
  get: () => ({
    queryKey: [{}],
    queryFn: () => getCompanyInfo(),
  }),
});
